<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">申购管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>申购记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input placeholder="请输入申购项目ID" clearable v-model="purchaseId">
        </el-input>
        <el-select v-model="type" placeholder="请选择类型">
          <el-option value="">请选择</el-option>
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select v-model="status" placeholder="请选择状态">
          <el-option value="">请选择</el-option>
          <el-option
            v-for="item in statusAll"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <span v-for="coin in Object.keys(rata)" :key="coin"
          >该项目中签率为：{{ coin }}：{{ rata[coin] * 100 }}%</span
        >
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';

export default {
  name: 'purchaseRecords',
  data() {
    return {
      purchaseId: '',
      type: '',
      status: '',
      types: [
        {
          value: '0',
          label: '多的钱转回'
        },
        {
          value: '1',
          label: '转认购币'
        },
        {
          value: '2',
          label: '转推荐奖励'
        }
      ],
      statusAll: [
        {
          value: '0',
          label: '处理中'
        },
        {
          value: '1',
          label: '成功'
        },
        {
          value: '2',
          label: '失败'
        },
        {
          value: '3',
          label: '超时'
        }
      ]
    };
  },
  components: {
    List
  },
  computed: {
    ...mapState('purchaseRecord', ['pagination', 'rata'])
  },
  methods: {
    ...mapActions('purchaseRecord', ['getRecords', 'winningRate']),
    handleSearch() {
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      const params = {};
      if (this.type) {
        params.type = this.type;
      }
      if (this.status) {
        params.status = this.status;
      }
      if (this.purchaseId) {
        params.purchaseId = this.purchaseId;
      }
      this.getRecords({
        ...params,
        ...this.pagination,
        ...data
      });
    },
    getrata(data = {}) {
      const params = {};
      if (this.purchaseId) {
        params.purchaseId = this.purchaseId;
      }
      this.winningRate({ ...params });
    }
  },
  mounted() {
    if (this.$route.params.purchaseId) {
      this.purchaseId = this.$route.params.purchaseId;
      this.getList();
      this.getrata();
    }
  }
};
</script>
